<template>
  <div class="app-container">
     <el-card class="box-card">
        <folded-panel infoName="基本信息">
          <div slot="content">
            <dynamic-form
              labelWidth="110px"
              :formConfig="formConfig"
              v-model="form"
              :showBtn="false"/>
          </div>
        </folded-panel>
     </el-card>
  </div>
</template>
<script>
import FoldedPanel from "@/components/FoldedPanel"
import "@/components/dynamic-form"
export default {
  components: {
    FoldedPanel
  },
  data() {
    return {
      form: {},
      formConfig: {
          formItemList: [
            {
              type: "input",
              key: "clientId",
              label: "单据编号",
              value: "",
              span: 8,
            },
            {
              type: "input",
              key: "clientName",
              label: "项目号",
              value: "",
              span: 8,
              rules: [
                {required: true, message: "客户法定名称不能为空", trigger: "blur"}
              ]
            },
            {
              label: '项目名',
              key: 'province',
              type: 'databox',
              span: 8,
              props: {
                label: 'name',
                value: ''
              },
              url: '/dynamic/listData',
              tableColumn: [
                {
                  property: "number",
                  label: "编码",
                  query: {
                    type: 'input'
                  }
                },
                {
                  property: "name",
                  label: "名称",
                  query: {
                    type: 'input'
                  }
                }
              ],
              extendParms: {queryFieldItem: 'id,number,name'},
              multiple: false,
              rules: {
                required: true, message: '不能为空', trigger: 'change'
              }
            },
            {
              label: '立项类型',
              key: 'city',
              type: 'databox',
              span: 8,
              props: {
                label: 'name',
                value: ''
              },
              url: '/dynamic/listData',
              tableColumn: [
                {
                  property: "number",
                  label: "编码",
                  query: {
                    type: 'input'
                  }
                },
                {
                  property: "name",
                  label: "名称",
                  query: {
                    type: 'input'
                  }
                }
              ],
              extendParms: {queryFieldItem: 'id,number,name'},
              multiple: false,
              rules: {
                required: true, message: '不能为空', trigger: 'change'
              }
            },
            {
              type: "input",
              key: "address",
              label: "来源单据号",
              value: "",
              span: 8,
              rules: [
                {required: true, message: "客户详细地址不能为空", trigger: "blur"}
              ]
            },
            {
              type: "input",
              key: "phone",
              label: "经营人",
              value: "",
              span: 8,
              rules: [
                {required: true, message: "客户电话不能为空", trigger: "blur"}
              ]
            },
            {
              type: "input",
              key: "postcode",
              label: "商机号",
              value: "",
              span: 8,
              rules: [
                {required: true, message: "客户电话不能为空", trigger: "blur"}
              ]
            },
            {
              span: 8,
              type: "input",
              label: "项目负责人",
              value: "",
            },
             {
              span: 8,
              type: "input",
              label: "人工成本预算",
              value: "",
            },
             {
              span: 8,
              type: "input",
              label: "人工成本耗费",
              value: "",
            },
             {
              span: 8,
              type: "input",
              label: "费用预算",
              value: "",
            },
            {
              type: "textarea",
              key: "",
              label: "备注",
              value: "",
              placeholder: "请输入备注",
              span: 16,
              rules: [
                {required: true, message: "备注不能为空", trigger: "blur"}
              ]
            }
          ]
        }
    }
  }
}
</script>
<style scoped>

</style>